import React from 'react'
//import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import 'bootstrap/dist/css/bootstrap.min.css'

const divStyle = {
  paddingRight: '0px',
  paddingTop: '50px',
}

const butStyle = {
  float: 'right',
  paddingRight: '0px',
}

const linkStyle = {
  float: 'right',
}

class AddButton extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return <div className="row justify-content-end" style={divStyle}><div className="col-md-2 offset-md-11" style={butStyle}><a href={this.props.link} className="btn btn-secondary" style={linkStyle}>Add employee</a></div></div>
  }
}

AddButton.propTypes = {
  link: PropTypes.string,
}

export default AddButton
